import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HelpIconModule } from "@shared-components/help-icon";
import { LearningPathBadgeModule } from "@shared-components/learning-path-badge/learning-path-badge.module";
import { JobEditModule } from "@app/jobs";
import { QuickbooksTaskDisplayModule } from "@app/quickbooks";
import { HeaderBarComponent } from "./header/header-bar.component";
import { GlobalSearchBarComponent } from "./header/global-search-bar/global-search-bar.component";
import { NotificationsComponent } from "./notifications/notifications.component";
import { TasksComponent } from "./tasks/tasks.component";
import { SideMenuComponent } from "./side-menu/side-menu.component";
import { FooterBarComponent } from "./footer/footer-bar.component";
import { TasksComponentsModule } from "@app/tasks/tasks-components/tasks-components.module"
import { AppointmentsModule } from "@app/appointments/appointments.module";
import { SlickAutoCompleteModule, SlickDialogModule, SlickDropDownModule, SlickPopoverModule } from "slick-components";
import { VersionReleaseDialogModule } from "@shared-components/version-release-dialog"
import { AiActivityComponent } from "@shared-components/ai-activity";
import { CustomersService, LoginService } from "@services"
import { CustomerEditModule } from "@app/customers/customer-edit/customer-edit.module";
import { VendorEditModule } from "@app/vendors/vendor-edit/vendor-edit.module";
import { SubcontractorEditModule } from "@app/subcontractors/subcontractor-edit/subcontractor-edit.module";
import { EquipmentEditModule } from "@app/equipment/equipment-edit/equipment-edit.module";
import { InvoicesComponentsModule } from "@app/invoices/invoices-components/invoices-components.module";
import { PaymentsComponentModule } from "@app/payments/payments-components/payment-components.module";
import { BusinessDevelopmentComponentsModule } from "@app/business-development/business-development-components/business-development-components.module";

@NgModule({
	imports: [
		CommonModule, FormsModule, RouterModule, HelpIconModule, LearningPathBadgeModule, JobEditModule, TasksComponentsModule,
		AppointmentsModule, VersionReleaseDialogModule, QuickbooksTaskDisplayModule,
		SlickAutoCompleteModule, SlickDialogModule, SlickDropDownModule, SlickPopoverModule,
		CustomerEditModule, VendorEditModule, SubcontractorEditModule, EquipmentEditModule,
		InvoicesComponentsModule, PaymentsComponentModule, BusinessDevelopmentComponentsModule,
		AiActivityComponent
	],
	declarations: [HeaderBarComponent, GlobalSearchBarComponent, TasksComponent, NotificationsComponent, SideMenuComponent, FooterBarComponent],
	exports: [HeaderBarComponent, SideMenuComponent, FooterBarComponent],
	providers: [CustomersService, LoginService]
})
export class LayoutModule {
}
